import { render, staticRenderFns } from "./LabelWithHint.vue?vue&type=template&id=2dafdef6"
import script from "./LabelWithHint.vue?vue&type=script&lang=ts"
export * from "./LabelWithHint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports